import Window from "../window/Window";
import Chart from "../Chart";

function Statistics({ data, functions }) {
  return (
    <Window
      id="statistics"
      title="Compétences estimées"
      default_opened
    >
      <Chart data={data.langages} title="Languages" />
      <div>
        <Chart data={data.logiciels} title="Logiciels" />
        <Chart data={data.frameworks} title="Frameworks" />
      </div>
    </Window>
  );
}

export default Statistics;
